import styled from '@emotion/styled';
import { fonts } from 'folio-common-components';

export const PageHeading = styled.h1`
  ${fonts.font500bold};
  margin: 0;
`;
